// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper--ZVNix{width:3rem}.o2--Ea4mR{fill:#0112aa}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Networks/O2/index.module.scss"],"names":[],"mappings":"AAAA,gBAAS,UAAU,CAAC,WAAI,YAAY","sourcesContent":[".wrapper{width:3rem}.o2{fill:#0112aa}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "wrapper--ZVNix",
	"o2": "o2--Ea4mR"
};
export default ___CSS_LOADER_EXPORT___;
